import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { config } from '../../../../config';
import { Log } from './log.model';

@Injectable()
export class LogService {
  constructor(private http: HttpClient) { }

  create(log: Log): Observable<any> {
    return this.http.post<{ data: Log }>(`${config.apiLocation}/v1/logs`, log);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/logs/log.service.ts